(function () {
    'use strict';

    angular.module('app.signInAuth0')
        .controller('SignInAuth0Controller', SignInAuth0Controller);

    SignInAuth0Controller.$inject = ['AuthService', '$scope'];

    function SignInAuth0Controller( AuthService, $scope) {

        var vm = this;
        vm.spinner = { active: false };

        vm.singInByAuthO = singInByAuthO;

        $scope.$on('isLoading', function (event, isLoading) {
            setTimeout(() => {
                vm.spinner.active = isLoading;
            }, 0);
        });

        function singInByAuthO() {
            vm.spinner.active = true;
            AuthService.auth0SingIn().finally(() => vm.spinner.active = false);
        }
    }
})();
